module.exports = __webpack_public_path__ + "media/images/countryrect/np-3598f1fe6dafdd6d186b97cc936d95e1.svg";